module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "race-question"
  }, [_c('modal', {
    attrs: {
      "name": "question"
    },
    on: {
      "before-close": _vm.onClose
    }
  }, [_c('div', {
    staticClass: "question-modal-content"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('i', {
    staticClass: "fa-solid fa-question-circle"
  }), _vm._v(" "), _c('h1', [_vm._v("Today's Question")])]), _vm._v(" "), _c('div', {
    staticClass: "question-textarea-wrapper"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.question),
      expression: "question"
    }],
    attrs: {
      "id": "Question",
      "maxlength": "255",
      "name": "question",
      "Placeholder": "enter your question here"
    },
    domProps: {
      "value": (_vm.question)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.question = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "question-button-wrapper"
  }, [_c('button', {
    staticClass: "btn btn--primary",
    attrs: {
      "disabled": _vm.isClicked
    },
    on: {
      "click": function($event) {
        _vm.isquestionId ? _vm.Update(_vm.question) : _vm.Save(_vm.question)
      }
    }
  }, [_vm._v(_vm._s(_vm.button))])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-99c0320c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/Question.vue
// module id = 1707
// module chunks = 1